// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { ActivityData, ActivityErrors, ActivityResponses, AnnotationsData, AnnotationsErrors, AnnotationsResponses, ApprovalsData, ApprovalsErrors, ApprovalsResponses, CancelData, CancelErrors, CancelJobData, CancelJobErrors, CancelJobResponses, CancelResponses, CapabilitiesData, CapabilitiesResponses, ChatData, ChatResponses, ChunkData, ChunkErrors, ChunkResponses, ClientLogsData, ClientLogsErrors, ClientLogsResponses, CodexCompleteData, CodexCompleteErrors, CodexCompleteResponses, CodexLoginData, CodexLoginResponses, CodexLogoutData, CodexLogoutResponses, ConversationsData, ConversationsResponses, DecideData, DecideDeviceData, DecideDeviceErrors, DecideDeviceResponses, DecideErrors, DecideResponses, DeviceListData, DeviceListResponses, EventsData, EventsResponses, FeedbackListData, FeedbackListResponses, HealthData, HealthResponses, JobsData, JobsErrors, JobsResponses, MeData, MeResponses, MessagesData, MessagesErrors, MessagesResponses, ModelsData, ModelsResponses, PairData, PairErrors, PairResponses, PositionData, PositionErrors, PositionResponses, PutSecretData, PutSecretErrors, PutSecretResponses, RemoteStatusData, RemoteStatusResponses, ResumeData, ResumeErrors, ResumeResponses, RevokeDeviceData, RevokeDeviceErrors, RevokeDeviceResponses, RunActionData, RunActionErrors, RunActionResponses, SavePositionData, SavePositionErrors, SavePositionResponses, SendFeedbackData, SendFeedbackErrors, SendFeedbackResponses, SetRemoteData, SetRemoteErrors, SetRemoteResponses, SourceAssetData, SourceAssetErrors, SourceAssetResponses, SourceData, SourceErrors, SourceFileData, SourceFileErrors, SourceFileResponses, SourcePageData, SourcePageErrors, SourcePageResponses, SourceResponses, SourcesData, SourcesErrors, SourcesResponses, SourceTextData, SourceTextErrors, SourceTextResponses, TurnCitationsData, TurnCitationsErrors, TurnCitationsResponses, UploadData, UploadErrors, UploadResponses, UsageData, UsageResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Run Action
 */
export const runAction = <ThrowOnError extends boolean = true>(options: Options<RunActionData, ThrowOnError>): RequestResult<RunActionResponses, RunActionErrors, ThrowOnError> => (options.client ?? client).post<RunActionResponses, RunActionErrors, ThrowOnError>({
    url: '/api/v1/actions/{action_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Activity
 */
export const activity = <ThrowOnError extends boolean = true>(options?: Options<ActivityData, ThrowOnError>): RequestResult<ActivityResponses, ActivityErrors, ThrowOnError> => (options?.client ?? client).get<ActivityResponses, ActivityErrors, ThrowOnError>({ url: '/api/v1/activity', ...options });

/**
 * Approvals
 *
 * 确认卡。status=all 返回最近 100 张（含已处理、已更新为新版本的），界面据此显示卡片状态。
 */
export const approvals = <ThrowOnError extends boolean = true>(options?: Options<ApprovalsData, ThrowOnError>): RequestResult<ApprovalsResponses, ApprovalsErrors, ThrowOnError> => (options?.client ?? client).get<ApprovalsResponses, ApprovalsErrors, ThrowOnError>({ url: '/api/v1/approvals', ...options });

/**
 * Decide
 *
 * 处理确认卡。卡片来自某个对话时，导师随后在那个对话里说明结果（outcome.followup）。
 */
export const decide = <ThrowOnError extends boolean = true>(options: Options<DecideData, ThrowOnError>): RequestResult<DecideResponses, DecideErrors, ThrowOnError> => (options.client ?? client).post<DecideResponses, DecideErrors, ThrowOnError>({
    url: '/api/v1/approvals/{approval_id}/decide',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Capabilities
 *
 * 能力目录：前端据此生成“这里能做什么”、命令面板与按钮；新能力只需后端注册即可出现。
 */
export const capabilities = <ThrowOnError extends boolean = true>(options?: Options<CapabilitiesData, ThrowOnError>): RequestResult<CapabilitiesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<CapabilitiesResponses, unknown, ThrowOnError>({ url: '/api/v1/capabilities', ...options });

/**
 * Chat
 */
export const chat = <ThrowOnError extends boolean = true>(options?: Options<ChatData, ThrowOnError>): RequestResult<ChatResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ChatResponses, unknown, ThrowOnError>({ url: '/api/v1/chat', ...options });

/**
 * Cancel
 */
export const cancel = <ThrowOnError extends boolean = true>(options: Options<CancelData, ThrowOnError>): RequestResult<CancelResponses, CancelErrors, ThrowOnError> => (options.client ?? client).post<CancelResponses, CancelErrors, ThrowOnError>({ url: '/api/v1/chat/{conversation_id}/cancel', ...options });

/**
 * Resume
 */
export const resume = <ThrowOnError extends boolean = true>(options: Options<ResumeData, ThrowOnError>): RequestResult<ResumeResponses, ResumeErrors, ThrowOnError> => (options.client ?? client).get<ResumeResponses, ResumeErrors, ThrowOnError>({ url: '/api/v1/chat/{conversation_id}/stream', ...options });

/**
 * Chunk
 */
export const chunk = <ThrowOnError extends boolean = true>(options: Options<ChunkData, ThrowOnError>): RequestResult<ChunkResponses, ChunkErrors, ThrowOnError> => (options.client ?? client).get<ChunkResponses, ChunkErrors, ThrowOnError>({ url: '/api/v1/chunks/{chunk_id}', ...options });

/**
 * Client Logs
 */
export const clientLogs = <ThrowOnError extends boolean = true>(options: Options<ClientLogsData, ThrowOnError>): RequestResult<ClientLogsResponses, ClientLogsErrors, ThrowOnError> => (options.client ?? client).post<ClientLogsResponses, ClientLogsErrors, ThrowOnError>({
    url: '/api/v1/client-logs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Conversations
 */
export const conversations = <ThrowOnError extends boolean = true>(options?: Options<ConversationsData, ThrowOnError>): RequestResult<ConversationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ConversationsResponses, unknown, ThrowOnError>({ url: '/api/v1/conversations', ...options });

/**
 * Messages
 *
 * 显示用的消息：由服务端历史转换而来，并在每轮回答上附回引文核验结果。
 */
export const messages = <ThrowOnError extends boolean = true>(options: Options<MessagesData, ThrowOnError>): RequestResult<MessagesResponses, MessagesErrors, ThrowOnError> => (options.client ?? client).get<MessagesResponses, MessagesErrors, ThrowOnError>({ url: '/api/v1/conversations/{conversation_id}/messages', ...options });

/**
 * Device List
 */
export const deviceList = <ThrowOnError extends boolean = true>(options?: Options<DeviceListData, ThrowOnError>): RequestResult<DeviceListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DeviceListResponses, unknown, ThrowOnError>({ url: '/api/v1/devices', ...options });

/**
 * Me
 */
export const me = <ThrowOnError extends boolean = true>(options?: Options<MeData, ThrowOnError>): RequestResult<MeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<MeResponses, unknown, ThrowOnError>({ url: '/api/v1/devices/me', ...options });

/**
 * Pair
 *
 * 手机申请配对：返回 6 位配对码，令牌写进只读 Cookie。已有未失效的申请或已配对时直接返回当前状态。
 */
export const pair = <ThrowOnError extends boolean = true>(options: Options<PairData, ThrowOnError>): RequestResult<PairResponses, PairErrors, ThrowOnError> => (options.client ?? client).post<PairResponses, PairErrors, ThrowOnError>({
    url: '/api/v1/devices/pair',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Decide Device
 */
export const decideDevice = <ThrowOnError extends boolean = true>(options: Options<DecideDeviceData, ThrowOnError>): RequestResult<DecideDeviceResponses, DecideDeviceErrors, ThrowOnError> => (options.client ?? client).post<DecideDeviceResponses, DecideDeviceErrors, ThrowOnError>({
    url: '/api/v1/devices/{device_id}/decide',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Device
 */
export const revokeDevice = <ThrowOnError extends boolean = true>(options: Options<RevokeDeviceData, ThrowOnError>): RequestResult<RevokeDeviceResponses, RevokeDeviceErrors, ThrowOnError> => (options.client ?? client).post<RevokeDeviceResponses, RevokeDeviceErrors, ThrowOnError>({ url: '/api/v1/devices/{device_id}/revoke', ...options });

/**
 * Events
 */
export const events = <ThrowOnError extends boolean = true>(options?: Options<EventsData, ThrowOnError>): RequestResult<EventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<EventsResponses, unknown, ThrowOnError>({ url: '/api/v1/events', ...options });

/**
 * Feedback List
 */
export const feedbackList = <ThrowOnError extends boolean = true>(options?: Options<FeedbackListData, ThrowOnError>): RequestResult<FeedbackListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<FeedbackListResponses, unknown, ThrowOnError>({ url: '/api/v1/feedback', ...options });

/**
 * Send Feedback
 *
 * 一键反馈：至少要有一句话或一张截图。
 */
export const sendFeedback = <ThrowOnError extends boolean = true>(options?: Options<SendFeedbackData, ThrowOnError>): RequestResult<SendFeedbackResponses, SendFeedbackErrors, ThrowOnError> => (options?.client ?? client).post<SendFeedbackResponses, SendFeedbackErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/feedback',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Health
 */
export const health = <ThrowOnError extends boolean = true>(options?: Options<HealthData, ThrowOnError>): RequestResult<HealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({ url: '/api/v1/health', ...options });

/**
 * Jobs
 */
export const jobs = <ThrowOnError extends boolean = true>(options?: Options<JobsData, ThrowOnError>): RequestResult<JobsResponses, JobsErrors, ThrowOnError> => (options?.client ?? client).get<JobsResponses, JobsErrors, ThrowOnError>({ url: '/api/v1/jobs', ...options });

/**
 * Cancel Job
 */
export const cancelJob = <ThrowOnError extends boolean = true>(options: Options<CancelJobData, ThrowOnError>): RequestResult<CancelJobResponses, CancelJobErrors, ThrowOnError> => (options.client ?? client).post<CancelJobResponses, CancelJobErrors, ThrowOnError>({ url: '/api/v1/jobs/{job_id}/cancel', ...options });

/**
 * Codex Complete
 *
 * 完成 ChatGPT 订阅登录（朝夕在服务器上时用）：登录后浏览器会跳到一个打不开的 localhost 网址，把它整段粘贴回来，
 * 由服务器用其中的授权码换取凭据。只认这次登录发起时的 state。
 */
export const codexComplete = <ThrowOnError extends boolean = true>(options: Options<CodexCompleteData, ThrowOnError>): RequestResult<CodexCompleteResponses, CodexCompleteErrors, ThrowOnError> => (options.client ?? client).post<CodexCompleteResponses, CodexCompleteErrors, ThrowOnError>({
    url: '/api/v1/settings/codex/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Codex Login
 *
 * 开始 ChatGPT 订阅登录：返回授权网址；回调由本机 1455 端口一次性接收，凭据存入密钥目录（0600）。
 */
export const codexLogin = <ThrowOnError extends boolean = true>(options?: Options<CodexLoginData, ThrowOnError>): RequestResult<CodexLoginResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CodexLoginResponses, unknown, ThrowOnError>({ url: '/api/v1/settings/codex/login', ...options });

/**
 * Codex Logout
 */
export const codexLogout = <ThrowOnError extends boolean = true>(options?: Options<CodexLogoutData, ThrowOnError>): RequestResult<CodexLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CodexLogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/settings/codex/logout', ...options });

/**
 * Models
 */
export const models = <ThrowOnError extends boolean = true>(options?: Options<ModelsData, ThrowOnError>): RequestResult<ModelsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ModelsResponses, unknown, ThrowOnError>({ url: '/api/v1/settings/models', ...options });

/**
 * Remote Status
 *
 * 外来访问：开关状态、Tailscale 是否在线、手机该填的地址、是否已发布到私网（服务器上是公网域名）。
 * 本机或已配对的设备可看。
 */
export const remoteStatus = <ThrowOnError extends boolean = true>(options?: Options<RemoteStatusData, ThrowOnError>): RequestResult<RemoteStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RemoteStatusResponses, unknown, ThrowOnError>({ url: '/api/v1/settings/remote', ...options });

/**
 * Set Remote
 *
 * 打开：记下开关并发布到私网；关闭：记下开关并从私网撤下（朝夕也会拒绝来自私网的请求）。
 * 只在 Mac 本机可操作：手机上关掉就把自己关在门外了。
 */
export const setRemote = <ThrowOnError extends boolean = true>(options: Options<SetRemoteData, ThrowOnError>): RequestResult<SetRemoteResponses, SetRemoteErrors, ThrowOnError> => (options.client ?? client).post<SetRemoteResponses, SetRemoteErrors, ThrowOnError>({
    url: '/api/v1/settings/remote',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Put Secret
 */
export const putSecret = <ThrowOnError extends boolean = true>(options: Options<PutSecretData, ThrowOnError>): RequestResult<PutSecretResponses, PutSecretErrors, ThrowOnError> => (options.client ?? client).put<PutSecretResponses, PutSecretErrors, ThrowOnError>({
    url: '/api/v1/settings/secrets/{name}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sources
 */
export const sources = <ThrowOnError extends boolean = true>(options?: Options<SourcesData, ThrowOnError>): RequestResult<SourcesResponses, SourcesErrors, ThrowOnError> => (options?.client ?? client).get<SourcesResponses, SourcesErrors, ThrowOnError>({ url: '/api/v1/sources', ...options });

/**
 * Source
 */
export const source = <ThrowOnError extends boolean = true>(options: Options<SourceData, ThrowOnError>): RequestResult<SourceResponses, SourceErrors, ThrowOnError> => (options.client ?? client).get<SourceResponses, SourceErrors, ThrowOnError>({ url: '/api/v1/sources/{source_id}', ...options });

/**
 * Annotations
 *
 * 这本书里的全部标注（划线、批注、插注），按在书里的先后排。
 */
export const annotations = <ThrowOnError extends boolean = true>(options: Options<AnnotationsData, ThrowOnError>): RequestResult<AnnotationsResponses, AnnotationsErrors, ThrowOnError> => (options.client ?? client).get<AnnotationsResponses, AnnotationsErrors, ThrowOnError>({ url: '/api/v1/sources/{source_id}/annotations', ...options });

/**
 * Source Asset
 *
 * 原件里的一张图（EPUB 的插图、公式图）。
 */
export const sourceAsset = <ThrowOnError extends boolean = true>(options: Options<SourceAssetData, ThrowOnError>): RequestResult<SourceAssetResponses, SourceAssetErrors, ThrowOnError> => (options.client ?? client).get<SourceAssetResponses, SourceAssetErrors, ThrowOnError>({ url: '/api/v1/sources/{source_id}/asset', ...options });

/**
 * Source File
 *
 * 原件（阅读器直接打开：EPUB 交给 foliate-js，PDF 交给 PDF.js，Markdown 原文）。
 *
 * 支持按字节区间读取（Range），大书在手机上只取需要的部分；内容按哈希不变，长期缓存。
 */
export const sourceFile = <ThrowOnError extends boolean = true>(options: Options<SourceFileData, ThrowOnError>): RequestResult<SourceFileResponses, SourceFileErrors, ThrowOnError> => (options.client ?? client).get<SourceFileResponses, SourceFileErrors, ThrowOnError>({ url: '/api/v1/sources/{source_id}/file', ...options });

/**
 * Source Page
 *
 * PDF 的一页版面（PNG）。
 */
export const sourcePage = <ThrowOnError extends boolean = true>(options: Options<SourcePageData, ThrowOnError>): RequestResult<SourcePageResponses, SourcePageErrors, ThrowOnError> => (options.client ?? client).get<SourcePageResponses, SourcePageErrors, ThrowOnError>({ url: '/api/v1/sources/{source_id}/pages/{page}', ...options });

/**
 * Position
 */
export const position = <ThrowOnError extends boolean = true>(options: Options<PositionData, ThrowOnError>): RequestResult<PositionResponses, PositionErrors, ThrowOnError> => (options.client ?? client).get<PositionResponses, PositionErrors, ThrowOnError>({ url: '/api/v1/sources/{source_id}/position', ...options });

/**
 * Save Position
 */
export const savePosition = <ThrowOnError extends boolean = true>(options: Options<SavePositionData, ThrowOnError>): RequestResult<SavePositionResponses, SavePositionErrors, ThrowOnError> => (options.client ?? client).put<SavePositionResponses, SavePositionErrors, ThrowOnError>({
    url: '/api/v1/sources/{source_id}/position',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Source Text
 *
 * 阅读视图：解析文本的块（码点区间），用于引文高亮定位。给出 start/end 时只返回与这个区间相交的块（按章阅读）。
 * EPUB 的插图与公式图按原处附在块上（figures），PDF 另有按页的版面。
 */
export const sourceText = <ThrowOnError extends boolean = true>(options: Options<SourceTextData, ThrowOnError>): RequestResult<SourceTextResponses, SourceTextErrors, ThrowOnError> => (options.client ?? client).get<SourceTextResponses, SourceTextErrors, ThrowOnError>({ url: '/api/v1/sources/{source_id}/text', ...options });

/**
 * Turn Citations
 *
 * 一轮回答里引文的逐字核验结果。
 */
export const turnCitations = <ThrowOnError extends boolean = true>(options: Options<TurnCitationsData, ThrowOnError>): RequestResult<TurnCitationsResponses, TurnCitationsErrors, ThrowOnError> => (options.client ?? client).get<TurnCitationsResponses, TurnCitationsErrors, ThrowOnError>({ url: '/api/v1/turns/{turn_id}/citations', ...options });

/**
 * Upload
 *
 * 只把原件写入内容寻址库（无副作用、可重复）；登记资料由动作 library.add_file 完成。
 */
export const upload = <ThrowOnError extends boolean = true>(options: Options<UploadData, ThrowOnError>): RequestResult<UploadResponses, UploadErrors, ThrowOnError> => (options.client ?? client).post<UploadResponses, UploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/api/v1/uploads',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Usage
 */
export const usage = <ThrowOnError extends boolean = true>(options?: Options<UsageData, ThrowOnError>): RequestResult<UsageResponses, unknown, ThrowOnError> => (options?.client ?? client).get<UsageResponses, unknown, ThrowOnError>({ url: '/api/v1/usage', ...options });
